export enum GameState {
    LOBBY,
    WIN_STAGE,
    WIN_CONTINENT,
    LOOSE,
    LOADING,
    GAMEPLAY
}
